import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { subDays } from "date-fns";
import { getAdminAxiosInstance } from "../../../../api/Admin";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  isEdit: false,
  startDate: subDays(new Date(), 30),
  endDate: new Date(),
  showCreateModal: false,
  showDeleteModal: false,
  clearSelection: false,
  selectedId: "",
  isLoading: false,
  customOfferListEditData: [],
};

const customOfferSlice = createSlice({
  name: "customOffers",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = customOfferSlice.actions;
export default customOfferSlice.reducer;
